import { render, staticRenderFns } from "./CollectionSlider.vue?vue&type=template&id=44544fbd&scoped=true&"
import script from "./CollectionSlider.vue?vue&type=script&lang=js&"
export * from "./CollectionSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44544fbd",
  null
  
)

export default component.exports